export const environment = {
  production: true,
  CI_COMMIT_SHA: process.env.CI_COMMIT_SHA,
  FULTONGRACE_URL: 'https://staging.fultongrace.com',
  STRIPE_PUBLISHABLE_KEY: 'pk_test_hMEJ9gyfHFlT31qkYtTqQm7B',
  DOMAIN: 'staging.fultongrace.com',
  ENV_NAME: 'stg',
  PAYLOAD_ORG_ID: 'acct_3dz1KCofB6sQ8P76sydN8',
};
